export function OutlineLockIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9548 11.002H5.94993C4.84712 11.002 3.95312 11.896 3.95312 12.9988V19.0036C3.95312 20.1064 4.84712 21.0004 5.94993 21.0004H17.9548C19.0576 21.0004 19.9516 20.1064 19.9516 19.0036V12.9988C19.9516 11.896 19.0576 11.002 17.9548 11.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9517 8.00161C16.9517 5.2416 14.7149 3 11.9501 3C9.18529 3 6.94849 5.2368 6.94849 8.00161V11.0016H9.94849V8.00161C9.94849 6.89761 10.8461 6.00001 11.9501 6.00001C13.0541 6.00001 13.9517 6.89761 13.9517 8.00161V11.0016H16.9517V8.00161Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9546 15V17.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
